import {UserAuthConfirmStepGenqlSelection} from "@/gql/gen";

export const UserAuthConfirmStepFields: UserAuthConfirmStepGenqlSelection = {
    CAPTION: true,
    CODE: true,
    NAME: true
} 